<script>
import DatePicker from "vue2-datepicker";
import EmployeeModal from "@/components/modals/employee.vue";
import { required } from "vuelidate/lib/validators";
export default {
    name: "InventoryForm",
    props: {
        modalTitle: {
            type: String,
            default: "Create Inventory",
        },
    },
    components: {
        DatePicker,
        EmployeeModal
    },
    validations: {
        form: {
            title: { required },
            startDate: { required },
            endDate: { required },
            type: { required },
        },
    },  
    data() {
        return {
            form: {
                id: 0,
                title: null,
                description: null,
                startDate: null,
                type: '',
                endDate:  null,
                inventoryChairSignatory: null,
                inventorySignatory: null,
                showInFinance: false
            },
            submitted: false,
            employeeSelection: 1
        };
    },
    methods: {
        onReset() {
            this.form = {
                id: 0,
                title: null,
                description: null,
                startDate: null,
                type: '',
                endDate:  null,
                inventoryChairSignatory: null,
                inventorySignatory: null,
                showInFinance: false
            };
            this.submitted = false;
        },
        updateData(data){
            this.form = JSON.parse(JSON.stringify(data));
            this.form.startDate = new Date(this.form.startDate);
            this.form.endDate = new Date(this.form.endDate);
            this.form.showInFinance = data.showInFinance === true || data.showInFinance === "true" || data.showInFinance === 1;
        },
        selectSignatory(type) {
            this.employeeSelection = type;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show("employee-modal");
        },
        dropSingleEmployee(data) {
            if(this.employeeSelection == 1){
                this.form.inventorySignatory = data.applicationUser.completeName;
            } else {
                this.form.inventoryChairSignatory = data.applicationUser.completeName;
            }
        },
        submitForm() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            let data = JSON.parse(JSON.stringify(this.form));
            data.startDate = this.getDate(new Date(this.form.startDate));
            data.endDate = this.getDate(new Date(this.form.endDate));
            this.$emit("submit", data);
        },
    },
};
</script>
<template>
    <b-modal
        id="inventory-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="submitForm" class="needs-validation" ref="fcForm">
            <div class="mb-3">
                <label for="title">Title </label>
                <input
                    id="title"
                    type="text"
                    v-model="form.title"
                    placeholder="Enter Title..."
                    class="form-control"
                    :class="{ 'is-invalid': submitted && (form.title == '' || form.title == null)}"
                    autocomplete="off"
                />
                <div 
                    v-if="submitted && $v.form.title.$error"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="startDate">Start Date</label>
                <date-picker
                    v-model="form.startDate"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Start Date..."
                    :class="{
                        'is-invalid':submitted && $v.form.startDate.$error
                    }"
                ></date-picker>
                <div 
                    v-if="submitted && $v.form.startDate.$error"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="endDate">End Date</label>
                <date-picker
                    v-model="form.endDate"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter End Date..."
                    :class="{
                        'is-invalid':submitted && $v.form.endDate.$error
                    }"
                ></date-picker>
                <div 
                    v-if="submitted && $v.form.endDate.$error"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="type">Type</label>
                <select
                    id="type"
                    v-model="form.type"
                    class="form-control"
                    autocomplete="off"
                    :class="{ 'is-invalid': submitted && $v.form.type.$error }"
                >
                    <option value="" disabled>Select Type...</option>
                    <option value="0">Semi-Expendable</option>
                    <option value="1">Property Plant Equipment</option>
                    <option value="3">Stocks</option>
                    <option value="2">All</option>
                </select>
                <div 
                    v-if="submitted && $v.form.type.$error"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="description">Description </label>
                <textarea
                    id="description"
                    rows="2"
                    v-model="form.description"
                    placeholder="Enter Description..."
                    class="form-control"
                    autocomplete="off"
                ></textarea>
            </div>
            <div class="mb-3">
                <label for="office-signatory">Inventory Signatory</label>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectSignatory(1)"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.inventorySignatory"
                    placeholder="Select signatory..."
                    class="form-control"
                  />
                </b-input-group>
            </div>
            <div class="mb-3">
                <label for="office-signatory">Inventory Chair Signatory</label>
                <b-input-group>
                  <template #append>
                    <b-button
                      @click="selectSignatory(2)"
                      variant="outline-info"
                      ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                  </template>
                  <input
                    autocomplete="off"
                    id="signatory"
                    type="text"
                    v-model="form.inventoryChairSignatory"
                    placeholder="Select signatory..."
                    class="form-control"
                  />
                </b-input-group>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <input
                        type="checkbox"
                        id="showInFinance"
                        class="form-check-input"
                        v-model="form.showInFinance"
                    />
                    <label class="form-check-label" for="showInFinance">
                        Show in Finance
                    </label>
                </div>
            </div>
            <div class="d-flex flex-row-reverse">
                <button type="submit" class="btn btn-primary">Create</button>
            </div>
        </form>
        
        <employee-modal
            ref="empModal"
            @dropData="dropSingleEmployee"
        ></employee-modal>
    </b-modal>
</template>